import { css } from "@emotion/react";
import { TooltipV3 } from "src/components/TooltipV3/TooltipV3.tsx";
import type { HTMLAttributes } from "react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { LoadingIndicator } from "src/components/DataGrid/product/LoadingIndicator.tsx";
import { ColumnGroupingCell } from "src/components/DataGrid/product/ColumnGroupingCell.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { getResourceFieldTranslation } from "src/system/getResourceFieldOptions.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import { ProductType } from "@exonn/js-sdk";

export function MultipleProductGroupingCell(
  props: HTMLAttributes<HTMLButtonElement> & {
    isExpanded: boolean;
    hasChildren: boolean;
    isLoading?: boolean;
    error?: any;
  },
) {
  const { isExpanded, hasChildren, isLoading = false, error, ...rest } = props;
  const hasError = !!error;
  const { t } = useTranslation(TranslationNamespaceEnum.Common);

  return (
    <TooltipV3
      delayDuration={500}
      content={getResourceFieldTranslation({
        t,
        resource: ResourceEnum.Product,
        type: "option_label",
        field: "type",
        value: ProductType.MULTIPLE,
      })}
      contentProps={{ align: "start" }}
    >
      <ColumnGroupingCell hasError={hasError} {...rest}>
        {isLoading && <LoadingIndicator />}
        {hasChildren && (
          <div
            css={triangleIconStyles({
              isExpanded,
              hasError,
            })}
          />
        )}

        <i className="icon-20-variant" />
      </ColumnGroupingCell>
    </TooltipV3>
  );
}

const triangleIconStyles =
  ({ isExpanded, hasError }: { isExpanded: boolean; hasError: boolean }) =>
  ({ colorsV2 }: ExactTheme) =>
    css({
      position: "absolute",
      width: 10,
      height: 10,
      right: 0,
      bottom: isExpanded ? "unset" : 0,
      clipPath: `polygon(100% 100%, 100% 0, 0 ${isExpanded ? 0 : 100}%)`,
      backgroundColor: isExpanded ? colorsV2.blue[500] : colorsV2.grey[200],
      transition: "background-color 0.3s",
      zIndex: 1,
    });
